import script from "./PistolShooting.vue?vue&type=script&setup=true&lang=js"
export * from "./PistolShooting.vue?vue&type=script&setup=true&lang=js"

import "./PistolShooting.vue?vue&type=style&index=0&id=41ba2dd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ba2dd0"]])

export default __exports__